import { parseNumberArg, parseStringArg } from '@/utils/string'

import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: 'wallet/:ownerType([a-zA-Z]+)/:ownerId(\\d+)',
    name: 'wallet-info',
    meta: { title: '钱包信息', componentName: 'WalletInfo' },
    component: () => import('@/views/pc/trade/WalletInfo.vue'),
    props: (to) => ({
      ownerId: parseNumberArg(to.params.ownerId),
      ownerType: parseStringArg(to.params.ownerType, 'upper')
    })
  },
  {
    path: 'profit/list',
    name: 'profit-list',
    meta: { title: '分润配置列表', componentName: 'ProfitConfigList' },
    component: () => import('@/views/pc/trade/ProfitConfigList.vue'),
    props: true
  },
  {
    path: 'profit/info',
    name: 'profit-info',
    meta: { title: '分润配置信息', componentName: 'ProfitConfigInfo' },
    component: () => import('@/views/pc/trade/ProfitConfigInfo.vue'),
    props: (to) => ({
      targetId: parseNumberArg(to.query.targetId),
      targetType: parseStringArg(to.query.targetType, 'upper')
    })
  }
] as RouteRecordRaw[]
